const options = {
  5: "bg-cyan-400/5",
  10: "bg-cyan-400/10",
  25: "bg-cyan-400/25",
  50: "bg-cyan-400/50",
  75: "bg-cyan-400/75",
  90: "bg-cyan-400/90",
  100: "bg-cyan-400",
};

const from = {
  5: "from-cyan-400/5",
  10: "from-cyan-400/10",
  25: "from-cyan-400/25",
  50: "from-cyan-400/50",
  75: "from-cyan-400/75",
  90: "from-cyan-400/90",
  100: "from-cyan-400",
};

export default function getBackgroundCyan400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
